import * as angular from "angular";
import {IController, IIntervalService, IQService} from "angular";
import {LogisticsVehicle} from "../../models/logistics-vehicle.model";
import {DocumentSettings} from "../../../site-preferences/models/document-settings.model";
import {Document} from "../../../commons/models/document.model";
import {ReminderSettings} from "../../../site-preferences/models/reminder-settings.model";
import {Reminder} from "../../../commons/models/reminder.model";
import * as _ from "lodash";
import {HolderType} from "../../../commons/types/holder.type";
import {LogisticsVehicleService} from "../../services/logistics-vehicle-service.service";
import {AttachmentsService} from "../../../attachments/services/attachments-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class LogisticsVehicleDocumentsAndRemindersCtrl implements IController {

  logisticsVehicle: LogisticsVehicle;
  documentsSettings: DocumentSettings[];
  documents: Document[];
  remindersSettings: ReminderSettings[]
  reminders: Reminder[];

  public documentsMap;
  public loadedDocument: string;
  public loadedReminder: string;
  public remindersMap;
  public editedReminder: string;
  public selectedDocumentsIds: string[];
  public selectedKeys: any = {};

  constructor(private uploadFile, private $log, private confirmDialogService: ConfirmDialogService, private $q: IQService,
              private $interval: IIntervalService,
              private logisticsVehicleService: LogisticsVehicleService, private attachmentsService: AttachmentsService) {
  }

  $onInit() {
    this.editedReminder = undefined;
    this.setDocumentsMap(this.documents);
    this.setRemindersMap(this.reminders);
  }

  onSelectAllDocuments() {
    if (_.isEmpty(this.selectedKeys)) {
      _.forEach(this.documentsSettings, (d) => {
        this.selectedKeys[d.id] = true;
      })
    } else {
      this.selectedKeys = {};
    }

    this.selectedDocumentsIds = _.values(this.selectedKeys);
  }

  onSelectDocument(selectedId) {
    if (this.selectedKeys[selectedId]) {
      _.unset(this.selectedKeys, selectedId);
    } else {
      this.selectedKeys[selectedId] = true;
    }

    this.selectedDocumentsIds = _.values(this.selectedKeys);
  }

  onDownloadSelectedDocuments() {
    const urlsDeferred = [];
    _.forOwn(this.selectedKeys, (value, key) => {
      const deferred = this.$q.defer();

      const documentRef = this.documentsMap[key];
      if (!!documentRef && documentRef.attachment) {
        urlsDeferred.push(deferred.promise);
        const isTemporaryUrl = documentRef.attachment.url.includes("Expires");
        const blobNameSplitted = documentRef.attachment.name.split('/');
        const blobNameCopy = blobNameSplitted[blobNameSplitted.length - 1];

        if (isTemporaryUrl && blobNameCopy) {
          this.attachmentsService.getAttachmentsUrls([blobNameCopy])
            .then((attachmentsUrls: any[]) => {
              const mapByName = _.mapKeys(attachmentsUrls, (value, key) => {
                return value.name;
              });
              deferred.resolve(_.get(mapByName[blobNameCopy], 'url'));
            });
        } else {
          deferred.resolve(documentRef.attachment.url);
        }
      }
    })


    this.$q.all(urlsDeferred).then((urls) => {
      const intervalRef = this.$interval(() => {
        var url = urls.pop();

        var a = document.createElement("a");
        a.setAttribute('href', url);
        a.setAttribute('download', '');
        a.setAttribute('target', '_blank');
        a.click();

        if (urls.length == 0) {
          this.$interval.cancel(intervalRef);
          this.selectedKeys = {};
          this.selectedDocumentsIds = [];
        }
      }, 300);
    })

  }

  uploadDocument($files, documentSettingsId) {
    this.loadedDocument = documentSettingsId;
    this.uploadFile($files[0])
      .then((response) => {
        const document = {
          attachment: {
            url: _.get(response, 'data.url'),
            name: _.get(response, 'data.blobName'),
            mimeType: _.get(response, 'data.contentType')
          },
          settingsId: documentSettingsId,
          holderType: HolderType.VEHICLE,
        }
        return this.logisticsVehicleService.createDocument(document, this.logisticsVehicle.id);
      })
      .then((createdDocument) => {
        _.set(this.documentsMap, [createdDocument.settingsId], createdDocument)
      })
      .catch((error) => {
        this.$log.error('Failed to upload document, logisticsVehicleInfo@uploadDocuments', error);
      })
      .finally(() => {
        this.loadedDocument = undefined;
      })
  }

  updateDocument($files, documentSettingsId) {
    this.loadedDocument = documentSettingsId;
    this.uploadFile($files[0])
      .then((response) => {

        const document = this.documentsMap[documentSettingsId];
        _.set(document, "attachment", {
          url: _.get(response, 'data.url'),
          name: _.get(response, 'data.blobName'),
          mimeType: _.get(response, 'data.contentType')
        })

        return this.logisticsVehicleService.updateDocument(document, this.logisticsVehicle.id);
      })
      .then((updatedDocument) => {
        _.set(this.documentsMap, [updatedDocument.settingsId], updatedDocument)
      })
      .catch((error) => {
        this.$log.error('Failed to upload document, logisticsVehicleInfo@updateDocuments', error);
      })
      .finally(() => {
        this.loadedDocument = undefined;
      })
  }

  onRemoveDocument(document, $event) {
    const title = 'Delete Document';
    const body = 'Are you sure you want to remove this document?';

    this.confirmDialogService.confirm(title, body, $event)
      .then(() => {
        this.removeDocument(document)
      })
      .catch(() => {
        this.$log.info('Dialog Closed');

      })
  }

  onReminderDeleted(reminderSettingsId, $event) {

    const title = 'Delete Reminder';
    const body = 'Are you sure you want to remove this reminder?';

    this.confirmDialogService.confirm(title, body, $event)
      .then(() => {
        this.removeReminder(reminderSettingsId)
      })
      .catch(() => {
        this.$log.info('Dialog Closed');

      })
  }

  onEditReminder(settingsId) {
    this.editedReminder = settingsId;
  }

  onCancelEditReminder() {
    this.editedReminder = undefined;
  }

  onSaveReminder(editedReminder, settingsId) {
    const reminder = this.remindersMap[settingsId];

    _.set(editedReminder, 'settingsId', settingsId);
    _.set(editedReminder, 'holderId', this.logisticsVehicle.id);
    _.set(editedReminder, 'holderType', HolderType.VEHICLE);

    if (!_.isUndefined(reminder)) {
      this.updateReminder(editedReminder);
    } else {
      this.createReminder(editedReminder);
    }
  }


  // ******************************
  //        Private Methods
  // ******************************


  private removeDocument(document: Document) {

    this.loadedDocument = document.settingsId;

    this.logisticsVehicleService.deleteDocument(document.id, this.logisticsVehicle.id)
      .then(() => {
        _.unset(this.documentsMap, [document.settingsId]);
      })
      .catch((error) => {
        this.$log.error('Failed to delete document, logisticsVehicleInfo@uploadDocuments', error);
      })
      .finally(() => {
        this.loadedDocument = undefined;
      })
  }


  private setRemindersMap(reminders: Reminder[]) {

    this.remindersMap = {};

    _.forEach(reminders, (re) => {
      _.set(this.remindersMap, [re.settingsId], re);
    })
  }

  private createReminder(reminder) {
    this.loadedReminder = reminder.settingsId;

    this.logisticsVehicleService.createReminder(reminder, this.logisticsVehicle.id)
      .then((createdReminder) => {
        this.remindersMap[createdReminder.settingsId] = createdReminder;
      })
      .finally(() => {
        this.editedReminder = undefined;
        this.loadedReminder = undefined;
      })
  }

  private updateReminder(reminder: Reminder) {
    this.loadedReminder = reminder.settingsId;
    this.logisticsVehicleService.updateReminder(reminder, this.logisticsVehicle.id)
      .then((updatedReminder) => {
        this.remindersMap[updatedReminder.settingsId] = updatedReminder;
      })
      .finally(() => {
        this.editedReminder = undefined;
        this.loadedReminder = undefined;
      })
  }

  private removeReminder(reminderSettingsId) {
    this.loadedReminder = reminderSettingsId;
    const reminder = this.remindersMap[reminderSettingsId];
    this.logisticsVehicleService.deleteReminder(reminder.id, this.logisticsVehicle.id)
      .then(() => {
        _.unset(this.remindersMap, [reminderSettingsId]);
      })
      .finally(() => {
        this.loadedReminder = undefined;
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private setDocumentsMap(documents: Document[]) {
    this.documentsMap = {};
    _.forEach(documents, (dc) => {
      _.set(this.documentsMap, [dc.settingsId], dc);
    })
  }
}

angular
  .module('bringoz.admin.logistics-vehicle')
  .component('logisticsVehicleDocumentsAndReminders', {
    bindings: {
      logisticsVehicle: '<',
      documentsSettings: '<',
      documents: '<',
      remindersSettings: '<',
      reminders: '<',

    },
    template: require('./logistics-vehicle-documents-and-reminders.html').default,
    controller: LogisticsVehicleDocumentsAndRemindersCtrl
  });
